(function($, undefined) {

	'use strict';
	var sitekey = '6Lcb53IUAAAAANte3pFbpj-7fKffMlEHxsyRuvQS';

	
	/* RECAPTCHA UTIL FUNCTION */
	/**
	 * Render recaptchas dynamically.
	 * @param   btn         An element referencing the button or a string 
	 *                      referencing the Id of the element.
	 * @param   callback    A function to be called after recaptcha has 
	 *                      completed its check. The function is passed back
	 *                      the recaptcha response and the form element.
	 * @param   validate    (optional) A boolean to know if a form needs to be 
	 *                      validated using the formValidator in com/form.js.
	 * @param   form        (optional) A jQuery object reference the form to be
	 *                      validated using formValidator in com/form.js.
	 */

	var recaptcha = function(btn, callback, validate, form) {
		if(btn && window.grecaptcha) {
			if (window.grecaptcha.render) {
				grecaptcha.render(btn, {
					'sitekey' : sitekey,
					'callback' : function(response) {
						var formValidator = Fw.component.models().form.validateForm;
						var validated = true;
						if(validate) {
							// console.log('validating');
							validated = false;	
							formValidator(form);
							if(!form.hasClass('has-error')) {
								validated = true;
							}
						}
						
						if(validated) {
							// console.log('calling callback');
							callback(response, form);
						} else {
							// console.log('resetting');
							grecaptcha.reset();
						}
					},
					'badge': 'inline'
				});
			} else {
				setTimeout(function() {
					recaptcha(btn, callback, validate, form);
				}, 250);
			}
		} else if(btn && !window.grecaptcha) {
			setTimeout(function() {
				recaptcha(btn, callback, validate, form);
			}, 250);
		}
	};

	var utils = Fw.component.export('utils', {
		recaptcha: recaptcha,
	});

})(jQuery);
